import { render, staticRenderFns } from "./requestaddform.vue?vue&type=template&id=4a7cb5e0"
import script from "./requestaddform.vue?vue&type=script&lang=js"
export * from "./requestaddform.vue?vue&type=script&lang=js"
import style0 from "./requestaddform.vue?vue&type=style&index=0&id=4a7cb5e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports